import { render, staticRenderFns } from "./BVeeCheckbox.vue?vue&type=template&id=08eaac44&"
import script from "./BVeeCheckbox.vue?vue&type=script&lang=js&"
export * from "./BVeeCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports